import { fetchCurrentModelsMarkdown } from '../utils/models.js';

export interface CurrentModelsOptions {
  url?: string;
}

export async function currentModels(options: CurrentModelsOptions = {}): Promise<void> {
  try {
    const { content } = await fetchCurrentModelsMarkdown(
      options.url ? [options.url] : undefined
    );

    process.stdout.write(content.endsWith('\n') ? content : `${content}\n`);
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Failed to fetch current models.';
    process.stderr.write(`${message}\n`);
    process.exit(1);
  }
}
